export default {
  languageOptionsLabel: 'プレビュー言語を選択',
  playAgainBtn: '再生',
  navbar: {
    backEdit: '編集に戻る',
    openBrowser: 'ブラウザで開く',
    logoTitle: 'マイプロジェクトに戻る',
  },
}
